var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 191,
    viewBox: "0 0 1440 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1949.36 997.297C1948.9 1547.51 1397.84 1993.08 718.527 1992.52C39.2173 1991.95 -511.098 1545.46 -510.636 995.247C-510.174 445.035 40.8896 -0.541012 720.2 0.0251788C1399.51 0.591369 1949.82 447.085 1949.36 997.297Z",
    fill: "#1F2358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.5a82e17626f9c8ec25f296b2c519e380.svg";
export { ForwardRef as ReactComponent };